const url = "https://papayaglobal.com/blog/papaya-acquires-remote-work-connectivity-platform-nicknack/";

export default url;